import type { IntegrationStatus } from "../../../shared/types";
import { statusLabels, statusTone } from "../../utils/status";

interface StatusChipProps {
  status: IntegrationStatus;
}

export function StatusChip({ status }: StatusChipProps) {
  return <span className={`status-chip status-${statusTone[status]}`}>{statusLabels[status]}</span>;
}
